import { Button } from '@mui/material';
import { object, shape } from 'prop-types';
import React, { Component } from 'react';
import { I18n } from 'utils/i18n';
import messageShape from 'shapes/message';
import connector from './connector';

class EditDraftButton extends Component {
  handleEdit = () => {
    const { actions, message } = this.props;
    actions.acknowledgmentPreviewModal.open(message);
  };

  render() {
    return (
      <Button
        color="secondary"
        variant="outlined"
        sx={{
          minWidth: '110px',
          fontSize: '15px',
          color: '#000',
        }}
        onClick={this.handleEdit}
      >
        {I18n.t('AcknowledgementMessage.Edit draft')}
      </Button>
    );
  }
}

EditDraftButton.propTypes = {
  message: messageShape.isRequired,
  actions: shape({
    acknowledgmentPreviewModal: object.isRequired,
  }).isRequired,
};

export default connector(EditDraftButton);
